.policies {
	display: flex;
	flex-direction: column;
	gap: var(--size-5);
}

.policyRow {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--size-4);
}

.policyInfo {
	display: flex;
	flex-direction: column;
	gap: var(--size-1);
}

.policyLabel {
	font-weight: 600;
}

.policyDescription {
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}
